// document.addEventListener('DOMContentLoaded', () => {
//   if (window.innerWidth <= 749) return;

//   const imageList = document.querySelector('.Athletes_story_athlete_image_list');
//   const firstImage = document.querySelector('.Athletes_story_athlete_image.active');

//   if (imageList && firstImage) {
//     imageList.scrollTo({
//         top: firstImage.offsetTop,
//         behavior: 'auto'
//     });
//   }

//   document.querySelectorAll('.Athletes_story_athlete_item').forEach((item) => {
//     item.addEventListener('mouseenter', () => {
//         const athleteHandle = item.dataset.athlete;

//         document
//             .querySelectorAll('.Athletes_story_athlete_item, .Athletes_story_athlete_image')
//             .forEach((el) => el.classList.remove('active'));

//         item.classList.add('active');

//         const targetImage = document.querySelector(
//             `.Athletes_story_athlete_image[data-athlete-image="${athleteHandle}"]`
//         );

//         if (!targetImage) return;

//         targetImage.classList.add('active');

//         imageList.scrollTo({
//             top:
//                 targetImage.offsetTop -
//                 (imageList.clientHeight / 2) +
//                 (targetImage.clientHeight / 2),
//             behavior: 'smooth'
//         });
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {

  // =========================
  // Desktop Active Item Sync
  // =========================

  if (window.innerWidth > 749) {

    const items = document.querySelectorAll('.Athletes_story_athlete_item');
    const images = document.querySelectorAll('.Athletes_story_athlete_image');
    const athleteList = document.querySelector('.Athletes_story_athlete_list');

    if (items.length && images.length) {

      let ticking = false;
      let isAutoScrolling = false;

      function syncActiveItemIntoView(athleteHandle, behavior = 'smooth') {

        if (!athleteList) return;

        const activeItem = Array.from(items).find(
          (item) => item.dataset.athlete === athleteHandle
        );

        if (!activeItem) return;

        const listRect = athleteList.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();

        const isAbove = itemRect.top < listRect.top;
        const isBelow = itemRect.bottom > listRect.bottom;

        if (isAbove || isBelow) {

          activeItem.scrollIntoView({
            behavior,
            block: 'nearest'
          });

        }

      }

      function setActive(athleteHandle, options = {}) {

        const {
          scrollList = true,
          behavior = 'smooth'
        } = options;

        items.forEach((item) => {

          item.classList.toggle(
            'active',
            item.dataset.athlete === athleteHandle
          );

        });

        images.forEach((image) => {

          image.classList.toggle(
            'active',
            image.dataset.athleteImage === athleteHandle
          );

        });

        if (scrollList) {

          syncActiveItemIntoView(
            athleteHandle,
            behavior
          );

        }

      }

      function updateActiveOnScroll() {

        if (isAutoScrolling) {

          ticking = false;
          return;

        }

        const viewportCenter = window.innerHeight / 2;

        let closestImage = null;
        let closestDistance = Infinity;

        images.forEach((image) => {

          const rect = image.getBoundingClientRect();

          const imageCenter =
            rect.top + rect.height / 2;

          const distance =
            Math.abs(
              imageCenter - viewportCenter
            );

          if (distance < closestDistance) {

            closestDistance = distance;
            closestImage = image;

          }

        });

        if (closestImage) {

          setActive(
            closestImage.dataset.athleteImage,
            {
              scrollList: true,
              behavior: 'smooth'
            }
          );

        }

        ticking = false;

      }

      // Click item -> scroll to image

      items.forEach((item) => {

        item.addEventListener('click', () => {

          const athleteHandle =
            item.dataset.athlete;

          const targetImage =
            document.querySelector(
              `.Athletes_story_athlete_image[data-athlete-image="${athleteHandle}"]`
            );

          if (!targetImage) return;

          isAutoScrolling = true;

          setActive(
            athleteHandle,
            {
              scrollList: true,
              behavior: 'smooth'
            }
          );

          const offset =
            targetImage.getBoundingClientRect().top +
            window.pageYOffset -
            window.innerHeight / 2 +
            targetImage.offsetHeight / 2;

          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });

          clearTimeout(window.scrollSyncTimeout);

          window.scrollSyncTimeout =
            setTimeout(() => {

              isAutoScrolling = false;

              updateActiveOnScroll();

            }, 1000);

        });

      });

      window.addEventListener('scroll', () => {

        if (!ticking) {

          window.requestAnimationFrame(
            updateActiveOnScroll
          );

          ticking = true;

        }

      });

      updateActiveOnScroll();

    }

  }


  // =========================
  // Mobile Active Item
  // =========================

  document.querySelectorAll(
    '.Athletes_story_athlete_item'
  ).forEach((item) => {

    item.addEventListener('click', () => {

      if (window.innerWidth > 749) return;

      document
        .querySelectorAll(
          '.Athletes_story_athlete_item'
        )
        .forEach((el) => {

          if (el !== item) {

            el.classList.remove(
              'active'
            );

          }

        });

      item.classList.add('active');

      setTimeout(() => {

        item.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      }, 100);

    });

  });


  // =========================
  // Popup Move To Body
  // =========================

  document.querySelectorAll(
    '.Athletes_story_athlete_popup_container'
  ).forEach((popup) => {

    popup.__originalParent =
      popup.parentNode;

    popup.__originalNextSibling =
      popup.nextElementSibling;

  });


  // =========================
  // Header Guard
  // =========================

  let athletesStoryHeaderGuard = null;

  function enforceIdleHeaderState() {

    const header =
      document.querySelector('.header');

    if (!header) return;

    header.dataset.stickyState = 'idle';

    header.dataset.scrollDirection =
      'none';

  }

  function startAthletesStoryHeaderGuard() {

    document.body.classList.add(
      'athletes-story-popup-open'
    );

    enforceIdleHeaderState();

    if (athletesStoryHeaderGuard)
      return;

    athletesStoryHeaderGuard =
      window.setInterval(() => {

        if (
          !document.body.classList.contains(
            'athletes-story-popup-open'
          )
        ) {

          window.clearInterval(
            athletesStoryHeaderGuard
          );

          athletesStoryHeaderGuard =
            null;

          return;

        }

        enforceIdleHeaderState();

      }, 100);

  }

  function stopAthletesStoryHeaderGuard() {

    document.body.classList.remove(
      'athletes-story-popup-open'
    );

    if (
      athletesStoryHeaderGuard
    ) {

      window.clearInterval(
        athletesStoryHeaderGuard
      );

      athletesStoryHeaderGuard =
        null;

    }

  }


  // =========================
  // Scroll Lock
  // =========================

  function lockAthletesStoryScroll() {

    document.body.classList.add(
      'overflow-hidden'
    );

    if (
      window.__agilitasLenis &&
      typeof window.__agilitasLenis.stop === 'function'
    ) {

      window.__agilitasLenis.stop();

    }

  }

  function unlockAthletesStoryScroll() {

    document.body.classList.remove(
      'overflow-hidden'
    );

    if (
      window.__agilitasLenis &&
      typeof window.__agilitasLenis.start === 'function'
    ) {

      window.__agilitasLenis.start();

    }

  }


  // =========================
  // Open Popup
  // =========================

  document.querySelectorAll(
    '.Athletes_story_athlete_story_link'
  ).forEach((link) => {

    link.addEventListener(
      'click',
      () => {

        const popup = link
          .closest(
            '.Athletes_story_athlete_item'
          )
          ?.querySelector(
            '.Athletes_story_athlete_popup_container'
          );

        if (!popup) return;


        // Move popup to body

        if (
          popup.parentNode !==
          document.body
        ) {

          document.body.appendChild(
            popup
          );

        }

        popup.classList.add(
          'active'
        );

        lockAthletesStoryScroll();

        startAthletesStoryHeaderGuard();

      }
    );

  });


  // =========================
  // Close Popup
  // =========================

  document.querySelectorAll(
    '.close_icon'
  ).forEach((closeBtn) => {

    closeBtn.addEventListener(
      'click',
      () => {

        const popup =
          closeBtn.closest(
            '.Athletes_story_athlete_popup_container'
          );

        if (!popup) return;

        popup.classList.remove(
          'active'
        );


        // Move popup back

        const parent =
          popup.__originalParent;

        const nextSibling =
          popup.__originalNextSibling;

        if (parent) {

          if (
            nextSibling &&
            nextSibling.parentNode ===
              parent
          ) {

            parent.insertBefore(
              popup,
              nextSibling
            );

          } else {

            parent.appendChild(
              popup
            );

          }

        }

        const hasActivePopup =
          document.querySelector(
            '.Athletes_story_athlete_popup_container.active'
          );

        if (!hasActivePopup) {

          unlockAthletesStoryScroll();

          stopAthletesStoryHeaderGuard();

        }

      }
    );

  });


  // =========================
  // Popup Slider
  // =========================

  document.querySelectorAll(
    '.Athletes_story_athlete_popup'
  ).forEach((popup) => {

    const slider =
      popup.querySelector(
        '.Athletes_story_popup_athlete_product_recommendation_slider'
      );

    if (!slider) return;

    new Swiper(slider, {

      slidesPerView: 4,

      spaceBetween: 10,

      direction: 'horizontal',

      mousewheel: {
        forceToAxis: true,
      },

      navigation: {

        nextEl:
          popup.querySelector(
            '.swiper-button-next'
          ),

        prevEl:
          popup.querySelector(
            '.swiper-button-prev'
          ),

      },

      breakpoints: {

        0: {
          slidesPerView: 1.38,
        },

        750: {
          slidesPerView: 2,
        },

        990: {
          slidesPerView: 3,
        },

        1280: {
          slidesPerView: 4,
        }

      }

    });

  });

});
